import React, { FC } from 'react';

import {
  Tab,
  Tabs,
  Flex,
  Center,
  Heading,
  TabList,
  TabPanel,
  TabPanels,
} from '@chakra-ui/react';

import { PickupsTab } from './PickupsTab';
import { DeliveriesTab } from './DeliveriesTab';
import { UserPill } from 'components/core/UserPill';

import { OpenItemsViewProps } from './OpenItems.props';

const _focus = { border: 'none' };
const _selected = { backgroundColor: 'primary.500', color: '#fff' };

const OpenItemsView: FC<OpenItemsViewProps> = () => {
  return (
    <Flex flex={1} direction="column" color="#262626" overflow="auto">
      <Flex mb={8} align="flex-start" justify="space-between">
        <Heading fontSize="24px">Open Items</Heading>

        <UserPill />
      </Flex>

      <Tabs variant="soft-rounded">
        <Center>
          <TabList
            p={1}
            w="440px"
            bg="#EFEFEF"
            borderRadius="20px"
            alignSelf="center"
            justifyContent="center">
            <Tab _selected={_selected} _focus={_focus} w="100%">
              Pending Deliveries
            </Tab>
            <Tab _selected={_selected} _focus={_focus} w="100%">
              Pending Counts
            </Tab>
          </TabList>
        </Center>
        <TabPanels>
          <TabPanel>
            <DeliveriesTab />
          </TabPanel>
          <TabPanel>
            <PickupsTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};

export default OpenItemsView;
